export default __webpack_public_path__ + "static/chatgpt-python-b5f064adc0789ce519ee12b47535f280.jpg";